export default __webpack_public_path__ + "static/media/hrProcessIcon.288f39d3.svg";